/*
 * This contains all the draginer groove option
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  none: {
    id: 'cwt.translations.noDrainerGrooves',
    defaultMessage: 'No drainer grooves',
  },
  drainerGrooves: {
    id: 'cwt.translations.drainerGrooves',
    defaultMessage: 'Drainer grooves',
  },
});
